import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/transaction-lifecycle/page.tsx");
